import {
    PackingSlip,
    PackingSlipState,
} from '../../types/packingSlipStatusResponse';
import {Shipment} from '../../models/shipment';
import getTodayAtMidnight from '../../utils/getTodayAtMidnight';
import getDateAtMidnight from '../../utils/getDateAtMidnight';
import convertTrackToTrackTrace from './convertTrackToTrackTrace';
import convertPackingSlipItemToShipmentItem from './convertPackingSlipItemToShipmentItem';
import filterCanceledPackingSlipItems from '../filters/filterCanceledPackingSlipItems';
import {TrackTrace} from '../../models/trackTrace';

const isDelivered = (tracks: Array<TrackTrace>): boolean => {
    return tracks.length === 0
        ? false
        : tracks.filter(track => !track.isDelivered).length === 0;
};

const isDelayed = (
    state: PackingSlipState,
    shippingDate: Date | null,
    deliveryDate: Date | null
): boolean => {
    if (
        shippingDate &&
        state !== PackingSlipState.SHIPPED &&
        shippingDate > getTodayAtMidnight()
    ) {
        return state !== PackingSlipState.PENDING_BACKORDER;
    }

    if (deliveryDate && deliveryDate > getTodayAtMidnight()) {
        return true;
    }

    return false;
};

const isProcessing = (state: PackingSlipState): boolean => {
    return [
        PackingSlipState.NEW,
        PackingSlipState.PROCESSING,
        PackingSlipState.PENDING_PICK,
        PackingSlipState.READY_PICK,
        PackingSlipState.PICKED,
    ].includes(state);
};

const convertPackingSlipToShipment = (packingSlip: PackingSlip): Shipment => {
    const shippingDate = getDateAtMidnight(new Date());
    const deliveryDate = getDateAtMidnight(new Date());
    const items = packingSlip.items
        .filter(filterCanceledPackingSlipItems)
        .map(item => convertPackingSlipItemToShipmentItem(item));
    const tracks = packingSlip.tracks.map(track =>
        convertTrackToTrackTrace(track)
    );

    return {
        id: packingSlip.id,
        tracks,
        items,
        shippingDate,
        deliveryDate,
        state: packingSlip.state,
        hasBackorder: items.find(item => item.isBackorder) !== undefined,
        hasSpecial: items.find(item => item.isSpecial) !== undefined,
        isPendingBackorder:
            packingSlip.state === PackingSlipState.PENDING_BACKORDER,
        isPendingAction: packingSlip.state === PackingSlipState.PENDING_ACTION,
        isProcessing: isProcessing(packingSlip.state),
        isShipped: packingSlip.state === PackingSlipState.SHIPPED,
        isDelayed: isDelayed(packingSlip.state, shippingDate, deliveryDate),
        isDelivered: isDelivered(tracks),
    };
};

export default convertPackingSlipToShipment;
